import request from '@/utils/request'

export function getPrizeList(params) {
  return request({
    url: '/admin/prize/list',
    method: 'get',
    params
  })
}

export function addPrize(data) {
  return request({
    url: '/admin/prize',
    method: 'post',
    data
  })
}

export function getPrizeDetail(id) {
  return request({
    url: `/admin/prize/${id}`,
    method: 'get'
  })
}

export function updatePrize(id, data) {
  return request({
    url: `/admin/prize/${id}`,
    method: 'put',
    data
  })
}

export function updatePrizeStatus(id, status) {
  return request({
    url: `/admin/prize/${id}/status`,
    method: 'put',
    params: { status }
  })
}

export function updatePrizeStock(id, stock) {
  return request({
    url: `/admin/prize/${id}/stock`,
    method: 'put',
    params: { stock }
  })
}